import SectionHeader from "./reusable/SectionHeader";

const About = () => {
  const activities = [
    { icon: "find_people", text: "Recruit qualified assistants" },
    {
      icon: "train",
      text: "Train assistants to be up to date with corporate values and emerging tech",
    },
    { icon: "place", text: "Place trained assistants with matching requests" },
  ];

  return (
    <div id="about" className="section_margin">
      <SectionHeader
        title="What we do"
        caption="We improve the productivity, efficiency and overall happiness of busy founders, executives and entrepreneurs by providing them with adept assistants."
      />
      <div className="flex flex-col lg:grid grid-cols-3 justify-items-center">
        {activities.map((activity, i) => {
          return (
            <div
              data-aos="fade-up"
              key={i}
              className="flex flex-col items-center text-center mt-4 lg:my-0"
            >
              <img
                className="p-3 sys_bg_primary rounded-md mb-2 lg:mb-6"
                src={`/assets/icons/${activity.icon}.svg`}
                alt={activity.icon}
              />
              <p className="text-normal lg:text-xl font-medium max-w-xs sys_black">
                {activity.text}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default About;
